let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let AuthedUserSession = require("../../utils/AuthedUserSession");
// const radio = require("ES/lib/react-pubsub-via-radio.js/radio");

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Authenticate_signin: {
				key: "callService",
				on: {
					succeeded(){
						this.setState({is_reloading: true});
						window.location.reload();//this will load in the new php session
					}
				}
			}
		};
	},
	// componentDidMount() {
	// 	radio("invalidate_Displaylists_cache").broadcast();
	// },
	getInitialState(){
		return {
			is_reloading: false,
			field_errors: {},
			default_values: {
				username: AuthedUserSession.last_login_username
			}
		};
	},
	__getFieldValue(ref_name){
		let node = _.has(this.refs, ref_name)
			? this.refs[ref_name]
			: null;

		return _.isString(node && node.value)
			? node.value
			: "";
	},
	__onSubmit: esUtils.wrapPreventDefault(function(){
		let username = this.__getFieldValue("username");
		let password = this.__getFieldValue("password");

		let field_errors = {};
		if(esUtils.isBlank(username)){
			field_errors["username"] = true;
		}
		if(esUtils.isBlank(password)){
			field_errors["password"] = true;
		}
		this.setState({field_errors: field_errors, default_values: {username: username}});
		if(!_.isEmpty(field_errors)){
			return;
		}
		this.RadioService_callService("Authenticate_signin", {username, password});
	}),
	render(){
		let ajax = this.state.Authenticate_signin;

		let {field_errors, is_reloading} = this.state;
		let default_values = this.state.default_values || {};

		let renderField = function(type, name, label){
			return dd.div({className: "form-group " + (field_errors[name] ? " has-error" : "")},
				dd.input({
					type,
					ref: name,
					name,
					placeholder: label,
					className: "form-control",
					defaultValue: default_values[name] || null,
					autoComplete: "on"
				})
			);
		};
		return dd.div(null,
			ErrorAlert({message: ajax.error}),
			LoadingWrap({
					is_loading: ajax.waiting || is_reloading,
					text: "Signing in..."
				},
				dd.form({onSubmit: this.__onSubmit},
					renderField("text", "username", "Username"),
					renderField("password", "password", "Password"),
					dd.div(null,
						dd.button({className: "btn btn-default btn-block"}, "Sign in")
					)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/signin/SigninForm.js